"use strict";

var _slicedToArray = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _exports$countryCodeT, _exports$ISO2_ISO_MAP, _exports$ISO_ISO2_MAP, _exports$UPPER_CASE_C, _exports$ISO2_CURRENC, _exports$BRAND_TO_SUP;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BRAND_TO_SUPPORTED_REGIONS_MAPPING = exports.storeCountryToCurrencyCodeMap = exports.isoCountryCodeMap = exports.countryCodeIsoMap = exports.ISO2_CURRENCY_FORMATTER_MAPPING = exports.UPPER_CASE_COUNTRY_NAME_TO_ISO2_MAPPING = exports.ISO_ISO2_MAPPING = exports.ISO2_ISO_MAPPING = exports.THLegacyCountryCode = exports.isIsoCountryCode2Char = exports.TIsoCountryCode2Char = exports.countryCodeToIsoCountryCodeMap = exports.MoneyFormatLocale = exports.IsoCountryCodeToCurrencyNameMap = exports.IsoCountryCode2Char = exports.IsoCountryCode = exports.CountryCodeToCurrencyNameMap = void 0;

var mapping_1 = require("../utils/mapping");

var money_1 = require("../utils/money");

var brand_1 = require("./brand");

var CountryCodeToCurrencyNameMap;

(function (CountryCodeToCurrencyNameMap) {
  CountryCodeToCurrencyNameMap["CA"] = "CAD";
  CountryCodeToCurrencyNameMap["CH"] = "CHF";
  CountryCodeToCurrencyNameMap["DE"] = "EUR";
  CountryCodeToCurrencyNameMap["GB"] = "GBP";
  CountryCodeToCurrencyNameMap["US"] = "USD";
  CountryCodeToCurrencyNameMap["ZA"] = "ZAR";
})(CountryCodeToCurrencyNameMap = exports.CountryCodeToCurrencyNameMap || (exports.CountryCodeToCurrencyNameMap = {}));

var IsoCountryCode;

(function (IsoCountryCode) {
  IsoCountryCode["CAN"] = "CAN";
  IsoCountryCode["CHE"] = "CHE";
  IsoCountryCode["DEU"] = "DEU";
  IsoCountryCode["GBR"] = "GBR";
  IsoCountryCode["USA"] = "USA";
  IsoCountryCode["ZAF"] = "ZAF";
})(IsoCountryCode = exports.IsoCountryCode || (exports.IsoCountryCode = {}));

var IsoCountryCode2Char;

(function (IsoCountryCode2Char) {
  IsoCountryCode2Char["CA"] = "CA";
  IsoCountryCode2Char["CH"] = "CH";
  IsoCountryCode2Char["DE"] = "DE";
  IsoCountryCode2Char["GB"] = "GB";
  IsoCountryCode2Char["US"] = "US";
  IsoCountryCode2Char["ZA"] = "ZA";
})(IsoCountryCode2Char = exports.IsoCountryCode2Char || (exports.IsoCountryCode2Char = {}));

var IsoCountryCodeToCurrencyNameMap;

(function (IsoCountryCodeToCurrencyNameMap) {
  IsoCountryCodeToCurrencyNameMap["CAN"] = "CAD";
  IsoCountryCodeToCurrencyNameMap["CHE"] = "CHF";
  IsoCountryCodeToCurrencyNameMap["DEU"] = "EUR";
  IsoCountryCodeToCurrencyNameMap["GBR"] = "GBP";
  IsoCountryCodeToCurrencyNameMap["USA"] = "USD";
  IsoCountryCodeToCurrencyNameMap["ZAF"] = "ZAR";
})(IsoCountryCodeToCurrencyNameMap = exports.IsoCountryCodeToCurrencyNameMap || (exports.IsoCountryCodeToCurrencyNameMap = {}));

var MoneyFormatLocale;

(function (MoneyFormatLocale) {
  MoneyFormatLocale["en-au"] = "en-au";
  MoneyFormatLocale["en-gb"] = "en-gb";
  MoneyFormatLocale["fr-ch"] = "fr-ch";
  MoneyFormatLocale["en-za"] = "en-za";
  MoneyFormatLocale["de"] = "de";
})(MoneyFormatLocale = exports.MoneyFormatLocale || (exports.MoneyFormatLocale = {}));

exports.countryCodeToIsoCountryCodeMap = (_exports$countryCodeT = {}, _defineProperty(_exports$countryCodeT, IsoCountryCode2Char.CA, IsoCountryCode.CAN), _defineProperty(_exports$countryCodeT, IsoCountryCode2Char.DE, IsoCountryCode.DEU), _defineProperty(_exports$countryCodeT, IsoCountryCode2Char.GB, IsoCountryCode.GBR), _defineProperty(_exports$countryCodeT, IsoCountryCode2Char.US, IsoCountryCode.USA), _defineProperty(_exports$countryCodeT, IsoCountryCode2Char.CH, IsoCountryCode.CHE), _defineProperty(_exports$countryCodeT, IsoCountryCode2Char.ZA, IsoCountryCode.ZAF), _exports$countryCodeT);
exports.TIsoCountryCode2Char = new mapping_1.Enum(IsoCountryCode2Char);

function isIsoCountryCode2Char(val) {
  try {
    mapping_1.cast(val, exports.TIsoCountryCode2Char);
  } catch (err) {
    return false;
  }

  return true;
}

exports.isIsoCountryCode2Char = isIsoCountryCode2Char;
var THLegacyCountryCode;

(function (THLegacyCountryCode) {
  THLegacyCountryCode["CAN"] = "CA";
  THLegacyCountryCode["USA"] = "US";
})(THLegacyCountryCode = exports.THLegacyCountryCode || (exports.THLegacyCountryCode = {})); // map 2-char ISO country codes to ISO country codes


exports.ISO2_ISO_MAPPING = (_exports$ISO2_ISO_MAP = {}, _defineProperty(_exports$ISO2_ISO_MAP, IsoCountryCode2Char.CA, IsoCountryCode.CAN), _defineProperty(_exports$ISO2_ISO_MAP, IsoCountryCode2Char.US, IsoCountryCode.USA), _defineProperty(_exports$ISO2_ISO_MAP, IsoCountryCode2Char.GB, IsoCountryCode.GBR), _defineProperty(_exports$ISO2_ISO_MAP, IsoCountryCode2Char.CH, IsoCountryCode.CHE), _defineProperty(_exports$ISO2_ISO_MAP, IsoCountryCode2Char.ZA, IsoCountryCode.ZAF), _defineProperty(_exports$ISO2_ISO_MAP, IsoCountryCode2Char.DE, IsoCountryCode.DEU), _exports$ISO2_ISO_MAP); // map ISO country codes to 2-char ISO country codes

exports.ISO_ISO2_MAPPING = (_exports$ISO_ISO2_MAP = {}, _defineProperty(_exports$ISO_ISO2_MAP, IsoCountryCode.CAN, IsoCountryCode2Char.CA), _defineProperty(_exports$ISO_ISO2_MAP, IsoCountryCode.USA, IsoCountryCode2Char.US), _defineProperty(_exports$ISO_ISO2_MAP, IsoCountryCode.GBR, IsoCountryCode2Char.GB), _defineProperty(_exports$ISO_ISO2_MAP, IsoCountryCode.CHE, IsoCountryCode2Char.CH), _defineProperty(_exports$ISO_ISO2_MAP, IsoCountryCode.ZAF, IsoCountryCode2Char.ZA), _defineProperty(_exports$ISO_ISO2_MAP, IsoCountryCode.DEU, IsoCountryCode2Char.DE), _exports$ISO_ISO2_MAP);
/**
 * Maps an upper case country name to the 2-char ISO Code
 */

exports.UPPER_CASE_COUNTRY_NAME_TO_ISO2_MAPPING = (_exports$UPPER_CASE_C = {}, _defineProperty(_exports$UPPER_CASE_C, 'CANADA', IsoCountryCode2Char.CA), _defineProperty(_exports$UPPER_CASE_C, 'GERMANY', IsoCountryCode2Char.DE), _defineProperty(_exports$UPPER_CASE_C, 'GREAT BRITAIN', IsoCountryCode2Char.GB), _defineProperty(_exports$UPPER_CASE_C, 'SOUTH AFRICA', IsoCountryCode2Char.ZA), _defineProperty(_exports$UPPER_CASE_C, 'SWITZERLAND', IsoCountryCode2Char.CH), _defineProperty(_exports$UPPER_CASE_C, 'UNITED KINGDOM', IsoCountryCode2Char.GB), _defineProperty(_exports$UPPER_CASE_C, 'UNITED STATES', IsoCountryCode2Char.US), _exports$UPPER_CASE_C);
exports.ISO2_CURRENCY_FORMATTER_MAPPING = (_exports$ISO2_CURRENC = {}, _defineProperty(_exports$ISO2_CURRENC, IsoCountryCode2Char.CA, money_1.toDollar(MoneyFormatLocale['en-au'])), _defineProperty(_exports$ISO2_CURRENC, IsoCountryCode2Char.US, money_1.toDollar(MoneyFormatLocale['en-au'])), _defineProperty(_exports$ISO2_CURRENC, IsoCountryCode2Char.GB, money_1.toDollar(MoneyFormatLocale['en-gb'])), _defineProperty(_exports$ISO2_CURRENC, IsoCountryCode2Char.CH, money_1.toDollar(MoneyFormatLocale['fr-ch'])), _defineProperty(_exports$ISO2_CURRENC, IsoCountryCode2Char.ZA, money_1.toDollar(MoneyFormatLocale['en-za'])), _defineProperty(_exports$ISO2_CURRENC, IsoCountryCode2Char.DE, money_1.toDollar(MoneyFormatLocale.de)), _exports$ISO2_CURRENC); // provide a reverse-lookup of the same

exports.countryCodeIsoMap = new Map(Object.entries(THLegacyCountryCode).map(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];

  return [value, IsoCountryCode[key]];
})); // provide a conversion table between ISO country code values and Tim Hortons

exports.isoCountryCodeMap = new Map(Object.entries(IsoCountryCode).map(function (_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];

  return [value, THLegacyCountryCode[key]];
}));
/**
 * Map a store's country to proper currency code.
 * Handles different input shapes since input is sanity data
 * Currently supports USA and Canada
 */

exports.storeCountryToCurrencyCodeMap = {
  CHE: 756,
  Canada: 124,
  DE: 978,
  GBR: 826,
  'Great Britain': 826,
  'South Africa': 710,
  Switzerland: 756,
  USA: 840,
  ZAF: 710,
  canada: 124,
  che: 756,
  de: 978,
  gbr: 826,
  'great britain': 826,
  'south africa': 710,
  switzerland: 756,
  usa: 840,
  zaf: 710
};
/**
 * Maps brand to supported regions
 */

exports.BRAND_TO_SUPPORTED_REGIONS_MAPPING = (_exports$BRAND_TO_SUP = {}, _defineProperty(_exports$BRAND_TO_SUP, brand_1.Brand.BK, [IsoCountryCode2Char.US, IsoCountryCode2Char.CA, IsoCountryCode2Char.GB, IsoCountryCode2Char.CH, IsoCountryCode2Char.ZA, IsoCountryCode2Char.DE]), _defineProperty(_exports$BRAND_TO_SUP, brand_1.Brand.LTW, [IsoCountryCode2Char.US]), _defineProperty(_exports$BRAND_TO_SUP, brand_1.Brand.PLK, [IsoCountryCode2Char.US, IsoCountryCode2Char.CA, IsoCountryCode2Char.CH]), _defineProperty(_exports$BRAND_TO_SUP, brand_1.Brand.TH, [IsoCountryCode2Char.CA, IsoCountryCode2Char.US]), _exports$BRAND_TO_SUP);